export const CHECKBOX_TAG_NAME = "checkbox" as const;

export const CHECKBOX_SCALE = 0.6 as const;

// Grows the ripple layer into a circle around the square, MUI style.
export const CHECKBOX_RIPPLE_SPREAD = "40%" as const;
